export default __webpack_public_path__ + "static/microsoft-partner-6eda73605540e1dc3eb332e1963e4423.png";